<div class="mb-3 date-entry-input">
    @if (label != null) {
        <label>{{ label }}</label>
    }
    @if (showRequired) {
        <span class="required-indicator">*</span>
    }
    @if (isReadOnly) {
        <div class="row">
            <div class="col-lg-4">
                Day
                <input [value]="date" class="form-control" readonly="true" />
            </div>
            <div class="col-lg-4">
                Month
                <input [value]="month" class="form-control" readonly="true" />
            </div>
            <div class="col-lg-4">
                Year
                <input [value]="yearText" class="form-control" readonly="true" />
            </div>
        </div>
    }
    @if (!isReadOnly) {
        <table class="date-entry-table">
            <tr>
                <td class="td-day">
                    <p-select
                        [options]="dates"
                        [(ngModel)]="date"
                        placeholder="date"
                        autoWidth="false"
                        (ngModelChange)="viewChanged()"
                        [showClear]="false"
                        [fluid]="true"
                    ></p-select>
                </td>
                <td class="td-month">
                    <p-select
                        [options]="months"
                        [(ngModel)]="month"
                        placeholder="month"
                        autoWidth="false"
                        (ngModelChange)="viewChanged()"
                        [showClear]="false"
                        [fluid]="true"
                    ></p-select>
                </td>
                <td class="td-year">
                    <p-inputMask mask="9999" [(ngModel)]="yearText" placeholder="year" slotChar="yyyy" (ngModelChange)="viewChanged()"></p-inputMask>
                </td>
            </tr>
        </table>
    }
    @if (controlDir && controlDir.invalid) {
        <span class="help-block">
            <span class="required-indicator">
                {{ getErrorMessage() }}
            </span>
        </span>
    }
</div>
